import { useEffect, useRef } from 'react'

import { isTransportError } from '@krp/client-runtime'
import type { MyResource, VatSourceActions } from '@krp/platform-ui'

/** Что оболочка «Номенклатура → Настройка» отдаёт карточке источника: ресурс, право на запись и счётчик общего «Обновить». */
export interface NomenclatureCardProps {
  resource: MyResource
  canWrite: boolean
  reloadToken: number
}

export const messageOf = (error: unknown): string =>
  isTransportError(error) ? error.message : error instanceof Error ? error.message : 'Служба не ответила'

/** Перечитать, когда нажали «Обновить» на всей вкладке (счётчик меняется) — не при первом показе. */
export function useReloadOn(token: number, reload: () => void) {
  const first = useRef(token)
  useEffect(() => {
    if (token !== first.current) reload()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])
}

const noop = () => undefined

/** Источнику без записи нужен только «Обновить»; остальные действия редактора ему не выдаются (редактора в vm нет). */
export const noEdit = (reload: () => void): VatSourceActions => ({
  reload,
  rateChanged: noop,
  groupChanged: noop,
  preview: noop,
  confirmChanged: noop,
  apply: noop,
  cancel: noop,
  close: noop,
})
